export default "__VITE_ASSET__CpOMvwQM__"